"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');



var _forms = require('shared/services/forms');
var _session = require('shared/selectors/session');
var _common = require('shared/selectors/org/common');

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _store = require('web/store');
var _hooks = require('web/services/hooks');
var _Spinner = require('web/components/Spinner');

var _FormEditor = require('./Editor/FormEditor'); var _FormEditor2 = _interopRequireDefault(_FormEditor);
var _SentTab = require('./Sent/SentTab'); var _SentTab2 = _interopRequireDefault(_SentTab);
var _SentFormView = require('./StatusView/SentFormView'); var _SentFormView2 = _interopRequireDefault(_SentFormView);
var _ImportMenu = require('./Import/ImportMenu'); var _ImportMenu2 = _interopRequireDefault(_ImportMenu);
var _UploadDialog = require('./Import/UploadDialog'); var _UploadDialog2 = _interopRequireDefault(_UploadDialog);
var _ScanQrDialog = require('./Import/ScanQrDialog'); var _ScanQrDialog2 = _interopRequireDefault(_ScanQrDialog);
var _Library = require('./Library'); var _Library2 = _interopRequireDefault(_Library);
var _common3 = require('./common');
var _Gated = require('./Gated'); var _Gated2 = _interopRequireDefault(_Gated);
var _useFormsGate = require('./useFormsGate');
require('./forms.scss');



/* The org's forms, read again (at most every 1.5 s) when one changes. */
const useFormsList = (orgKey) => {
  const [listing, setListing] = _react.useState(null)
  const [error, setError] = _react.useState(null)
  _react.useEffect.call(void 0, () => {
    let isCurrent = true
    setListing(null)
    setError(null)
    const load = () => _forms.listForms.call(void 0, { OrgKey: orgKey })
      .then(r => { if (isCurrent) { setListing(r); setError(null) } })
      .catch((e) => { if (isCurrent) setError(_forms.formsErrorText.call(void 0, e, "Couldn't load your forms. Reload to try again.")) })
    load()
    const refresh = _common3.throttle.call(void 0, () => { load() }, 1500)
    const stop = _forms.onFormChanged.call(void 0, n => { if (n.OrgKey === orgKey && n.FormKey) refresh() })
    return () => {
      isCurrent = false
      refresh.cancel()
      stop()
    }
  }, [orgKey])
  return { listing, error }
}

const openEditor = (orgKey) => (formKey) => _store.history.push(_common3.editorRoute.call(void 0, orgKey, formKey))








/* Forms: Library · Sent, and Import a form. */
const FormsFrame = ({ orgKey, tab, orgPicker }) => {
  const { listing, error } = useFormsList(orgKey)
  const [dialog, setDialog] = _react.useState(null)
  const openUpload = _react.useCallback.call(void 0, () => setDialog('upload'), [])
  const openScan = _react.useCallback.call(void 0, () => setDialog('scan'), [])
  const closeDialog = _react.useCallback.call(void 0, () => setDialog(null), [])
  const onOpen = _react.useMemo.call(void 0, () => openEditor(orgKey), [orgKey])
  const onImported = _react.useCallback.call(void 0, (form) => {
    setDialog(null)
    onOpen(form.FormKey)
  }, [onOpen])
  const knownFormKeys = _react.useMemo.call(void 0, () => _nullishCoalesce(_optionalChain([listing, 'optionalAccess', _ => _.Forms, 'access', _2 => _2.map, 'call', _3 => _3(f => f.FormKey)]), () => ( [])), [listing])
  const count = _optionalChain([listing, 'optionalAccess', _4 => _4.Forms, 'access', _5 => _5.length])

  return (
    _react2.default.createElement('div', { className: "forms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
      , _react2.default.createElement('header', { className: "forms--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
        , _react2.default.createElement('h1', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, "Forms")
        ,  orgPicker 
        , _react2.default.createElement('div', { className: "forms--tabs", role: "tablist", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
          , _react2.default.createElement('button', {
            type: "button", role: "tab", 'aria-selected': tab === 'library',
            className: _classBuilder2.default.call(void 0, 'forms--tab', tab === 'library' && 'is-on'),
            onClick: () => _store.history.push(_routes2.default.FORMS.ROOT), __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
, "Library"
            ,  count ? _react2.default.createElement('span', { className: "forms--tab-count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}},  count ) : null 
          )
          , _react2.default.createElement('button', {
            type: "button", role: "tab", 'aria-selected': tab === 'sent',
            className: _classBuilder2.default.call(void 0, 'forms--tab', tab === 'sent' && 'is-on'),
            onClick: () => _store.history.push(_routes2.default.FORMS.SENT), __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
, "Sent"

          )
        )
        , _react2.default.createElement('span', { className: "forms--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}} )
        , _react2.default.createElement(_ImportMenu2.default, { onUpload: openUpload, onScan: openScan, __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}} )
      )
      , _react2.default.createElement('div', { className: "forms--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
        ,  tab === 'sent' && _react2.default.createElement(_SentTab2.default, { orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}} ) 
        ,  tab === 'library' && (
          error
            ? _react2.default.createElement('p', { role: "alert", className: "forms--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}},  error )
            : !listing
                ? _react2.default.createElement('div', { className: "forms-loading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}, _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 107}} ))
                : listing.Forms.length === 0
                  ? _react2.default.createElement(_Library.LibraryEmpty, { onUpload: openUpload, onScan: openScan, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}} )
                  : _react2.default.createElement(_Library2.default, { forms: listing.Forms, firstPages: listing.FirstPages, isAdmin: listing.IsAdmin, onOpen: onOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}} )
        )
      )
      , _react2.default.createElement(_UploadDialog2.default, { isOpen: dialog === 'upload', orgKey: orgKey, onClose: closeDialog, onImported: onImported, __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}} )
      , _react2.default.createElement(_ScanQrDialog2.default, {
        isOpen: dialog === 'scan',
        orgKey: orgKey,
        knownFormKeys: knownFormKeys,
        onClose: closeDialog,
        onOpenDraft: onOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
      )
    )
  )
}

const OrgPicker = ({ orgKeys, value, onChange }) => {
  const names = _hooks.useAppSelector.call(void 0, state => orgKeys.map(k => _nullishCoalesce(_optionalChain([_common.selectOrgV1.call(void 0, state, k ), 'optionalAccess', _6 => _6.Name]), () => ( ''))).join('\n')).split('\n')
  return (
    _react2.default.createElement('select', { className: "forms--org", 'aria-label': "Organization", value: value, onChange: e => onChange(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
      ,  orgKeys.map((k, i) => _react2.default.createElement('option', { key: k, value: k, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}},  names[i] )) 
    )
  )
}

/* The picked org's forms (none when it has no Forms). With no org picked
 * (My Inbox), the first of your Forms orgs, with a picker when there are
 * several. */
const SelectedOrgFrame = ({ tab }) => {
  const selected = _hooks.useAppSelector.call(void 0, _session.selectExplicitlySelectedOrgKey)
  const selectedGate = _useFormsGate.useFormsGate.call(void 0, selected)
  const anyGate = _useFormsGate.useAnyOrgHasForms.call(void 0, )
  const formsOrgKeys = _useFormsGate.useFormsOrgKeys.call(void 0, )
  const [picked, setPicked] = _react.useState(null)
  if (selected) {
    return _react2.default.createElement(_Gated2.default, { gate: selectedGate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}},  selected && _react2.default.createElement(FormsFrame, { key: selected, orgKey: selected, tab: tab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}} ) )
  }
  const orgKey = picked && formsOrgKeys.includes(picked) ? picked : formsOrgKeys[0]
  const picker = formsOrgKeys.length > 1 && orgKey
    ? _react2.default.createElement(OrgPicker, { orgKeys: formsOrgKeys, value: orgKey, onChange: setPicked, __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}} )
    : null
  return _react2.default.createElement(_Gated2.default, { gate: anyGate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}},  orgKey && _react2.default.createElement(FormsFrame, { key: orgKey, orgKey: orgKey, tab: tab, orgPicker: picker, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}} ) )
}

const EditorRoute = () => {
  const { orgKey, formKey } = _reactrouterdom.useRouteMatch(_routes2.default.FORMS.EDITOR).params
  const gate = _useFormsGate.useFormsGate.call(void 0, orgKey)
  return _react2.default.createElement(_Gated2.default, { gate: gate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}, _react2.default.createElement(_FormEditor2.default, { key: `${orgKey}/${formKey}`, orgKey: orgKey, formKey: formKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}} ))
}

const SentFormRoute = ({ match }) => {
  const gate = _useFormsGate.useAnyOrgHasForms.call(void 0, )
  return _react2.default.createElement(_Gated2.default, { gate: gate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}, _react2.default.createElement(_SentFormView2.default, { key: match.params.code, code: match.params.code, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}} ))
}

const renderLibrary = () => _react2.default.createElement(SelectedOrgFrame, { tab: "library", __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}} )
const renderSent = () => _react2.default.createElement(SelectedOrgFrame, { tab: "sent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}} )

/* Every #/forms route but the phone scan page, which has no sidebar. */
const FormsScreen = () => (
  _react2.default.createElement(_reactrouterdom.Switch, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
    , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.FORMS.SENT_FORM, component: SentFormRoute, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}} )
    , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.FORMS.SENT, render: renderSent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}} )
    , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.FORMS.EDITOR, component: EditorRoute, __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}} )
    , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.FORMS.ROOT, render: renderLibrary, __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}} )
    , _react2.default.createElement(_reactrouterdom.Redirect, { to: _routes2.default.FORMS.ROOT, __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}} )
  )
)

exports. default = FormsScreen
